import { NormalizedCacheObject } from 'apollo-boost';

import { NewProduct, Product, ServerProduct } from '../typings/products';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';
import { DNAApolloClient } from './DNAApolloClient/DNAApolloClient';
import { RestApiManager } from './RestApiManager';

export class ProductsDataProvider extends BaseDataProvider {
    private apiManager: RestApiManager;

    constructor(
        apiManager: RestApiManager,
        client: DNAApolloClient<NormalizedCacheObject>
    ) {
        super(client);
        this.apiManager = apiManager;
    }

    public fetchProductsData() {
        return this.apiManager
            .fetchProducts()
            .then(
                (res): Product[] =>
                    res.result.map(product => getProduct(product))
            );
    }

    public addNewProduct(product: NewProduct) {
        const requestParams: RequestInit = {
            method: 'POST',
            body: JSON.stringify({
                productName: product.productName,
                productDescription: product.description
            })
        };

        return this.apiManager
            .fetchAddProduct(requestParams)
            .then(res => getProduct(res.result));
    }

    public changeProduct(product: Product) {
        const requestParams = {
            method: 'POST',
            body: JSON.stringify({
                productId: Number(product.id),
                productDescription: product.description
            })
        };

        return this.apiManager
            .fetchChangeProduct(requestParams)
            .then(res => getProduct(res.result));
    }
}

function getProduct(product: ServerProduct): Product {
    return {
        id: product.productId.toString(),
        productName: product.productName,
        description: product.productDescription || '',
        ulogin: product.productLogin || ''
    };
}
